module.exports = __webpack_public_path__ + "assets/img/portfolio-ketvirtas-2x.f76f93df.jpg";